module.exports = __webpack_public_path__ + "img/DSC_2842.489ba0be.jpg";